import cn from 'classnames';
import type React from 'react';
import type { SelectableOption } from 'library/models/shop';
import * as st from './index.module.scss';

type Props = {
  isDisabled: boolean;
  isActive: boolean;
  isHighlighted: boolean;
  option: SelectableOption;
};

const Color: React.FC<Props> = ({ isDisabled, isActive, isHighlighted, option }: Props) => {
  return (
    <div
      className={cn(st.button, st.color, isDisabled && st.disabled)}
      style={{
        boxShadow: isActive
          ? '0 0 0 2px #4198C5'
          : isHighlighted
            ? '0 0 0 2px #D0021B'
            : `0 0 0 2px #f1f2f3`,
      }}
    >
      <div
        className={st.button_background}
        style={{
          backgroundColor: `${option.code}`,
          boxShadow: isActive ? `0 0 0 1px #f1f2f3` : `0 0 0 1px #${option.code}`,
        }}
      ></div>
    </div>
  );
};

export default Color;
